import { Button, FlexRow, Grid } from "atoms";
import { type Artist, type Project, ReviewableCard } from "features/reviewable";

type CollectiveArtistListProps = {
  artists: (Project | Artist)[];
  loadMore?: VoidFunction;
};

function CollectiveArtistList({
  artists,
  loadMore,
}: CollectiveArtistListProps) {
  if (artists.length === 0) return null;

  return (
    <>
      <Grid>
        {artists.map((artist) => (
          <ReviewableCard key={artist.id} {...artist} />
        ))}
      </Grid>
      {loadMore && (
        <FlexRow justifyContent="center">
          <Button size="xs" variant="secondary" onClick={loadMore}>
            Load More Artists...
          </Button>
        </FlexRow>
      )}
    </>
  );
}

export { CollectiveArtistList };
